import { lightTheme } from "./themes";

type ThemeColors = typeof lightTheme.colors;

/**
 * A styled-components interpolation reading one colour token from the active theme (light and
 * dark both define the same keys). A tree with no ThemeProvider reads the light theme.
 */
export const themeColor =
  (pick: (colors: ThemeColors) => string) =>
  ({ theme }: { theme?: { colors?: Partial<ThemeColors> } }): string =>
    pick({ ...lightTheme.colors, ...(theme?.colors ?? {}) } as ThemeColors);
